<script>
	let audio;

	function playAudio() {
		if (!audio) {
			audio = new Audio('/assets/troskujsemtoposral.mp3');
		}

		if (audio.paused) {
			audio.play();
		} else {
			audio.pause();
			audio.currentTime = 0;
		}
	}
</script>

<main>
	<img src="/assets/babis.jpg" alt="Centered Image">
	<i class="fas fa-volume-up speaker-icon" on:click="{playAudio}"></i>
</main>

<style>
	main {
		height: 100%;
		margin: 0;
		padding: 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	img {
		display: block;
		max-width: 100%;
		max-height: 100%;
	}

	.speaker-icon {
		font-size: 48px;
		margin-top: 20px;
		cursor: pointer;
		transition: transform 0.2s, color 0.2s;
	}

	.speaker-icon:hover {
		transform: scale(1.1);
		color: #1a73e8;
	}
</style>

